export class Exception extends Error {
  //
}
